import { useSearchParams } from 'react-router-dom';
import { useGetMeApi } from 'eds-common/api/v2';
import {
  useEffectiveClassIds,
  useEffectiveStudentIds,
} from '@data/hooks/use-effective-filters/use-effective-filters';
import { useReportOutletContext } from '@data/pages/ReportLayout/ReportLayout';
import { getEdApps } from '@data/utils/get-ed-apps';

/**
 * The part of a teacher metrics request every table on a report shares — the
 * signed-in teacher, the date range and the effective classes and students —
 * and whether it is ready to send.
 */
export function useTeacherMetricsArgs() {
  const { dateRange, drilldown, productId: edApp } = useReportOutletContext();
  const { data: user } = useGetMeApi();
  const [searchParams] = useSearchParams();
  const classIds = searchParams.getAll('classId');
  const studentIds = searchParams.getAll('studentId');
  const orgId = user?.currentOrg?.orgId ?? '';

  const effectiveClassIds = useEffectiveClassIds({
    orgId,
    userId: user?.userId ?? '',
    edApp,
    selectedClassIds: classIds,
  });
  const { studentIds: effectiveStudentIds, isReady: studentsReady } =
    useEffectiveStudentIds({
      drilldown,
      classIds,
      edApp,
      selectedStudentIds: studentIds,
    });

  return {
    args: {
      orgId,
      teacherIds: [user?.userId ?? ''],
      startDate: dateRange.from,
      endDate: dateRange.to,
      edApps: getEdApps(edApp),
      classIds: effectiveClassIds,
      studentIds: effectiveStudentIds,
    },
    ready:
      !!user?.userId &&
      !!orgId &&
      !!edApp &&
      effectiveClassIds.length > 0 &&
      studentsReady,
  };
}
